import { ErrorLike } from '../interfaces/api/common.interface';

const SUPPORT_CODE_REGEX = /\s*Código de soporte:\s*\S+/g;

function resolveLocalizedObject(
  obj: Record<string, string>,
  language: string,
): string | undefined {
  return obj[language] ?? obj['es'] ?? undefined;
}

function parseJsonMessage(
  raw: string,
  language: string,
): string {
  const cleanPart = raw.replace(SUPPORT_CODE_REGEX, '').trim();

  try {
    const parsed = JSON.parse(cleanPart);
    if (parsed && typeof parsed === 'object') {
      const localized = resolveLocalizedObject(parsed as Record<string, string>, language);
      return localized ?? cleanPart;
    }
  } catch {
    // not JSON — return plain message
  }

  return cleanPart;
}

export function extractErrorMessage(
  error: ErrorLike,
  language: string,
  fallback: string,
): string {
  const raw = error?.error?.message;

  if (!raw) return fallback;

  if (typeof raw === 'object') {
    return resolveLocalizedObject(raw as Record<string, string>, language) ?? fallback;
  }

  if (typeof raw === 'string') {
    return parseJsonMessage(raw, language);
  }

  return fallback;
}
